import { StandardCSSProperties } from '../types.js';

export function stringOrNumberDefined(
  value: string | number,
  whenString: keyof StandardCSSProperties | (keyof StandardCSSProperties)[],
  whenNumber: (val: number) => {
    className?: string;
    style?: StandardCSSProperties;
  },
): {
  className?: string;
  style?: StandardCSSProperties;
} {
  if (typeof value === 'string') {
    if (Array.isArray(whenString)) {
      return {
        style: whenString.reduce(
          (acc, key) => ({
            ...acc,
            [key]: value,
          }),
          {} as StandardCSSProperties,
        ),
      };
    }
    return {
      style: {
        [whenString]: value,
      } as StandardCSSProperties,
    };
  }
  return whenNumber(value);
}
